{
	"agents": [
		{
			"agentType": "figma",
			"accountId": "712020:mock-agent-figma",
			"displayName": "Figma session",
			"views": 92,
			"created": 3,
			"updated": 2,
			"commentCreated": 1,
			"searchPerformed": 0,
			"relatedUserAccountId": "712020:mock-human-alex",
			"relatedUserDisplayName": "Alex Rivera",
			"lastViewedAt": "2026-08-21T15:20:00.000Z"
		},
		{
			"agentType": "lovable",
			"accountId": "712020:mock-agent-lovable",
			"displayName": "Lovable session",
			"views": 85,
			"created": 4,
			"updated": 1,
			"commentCreated": 0,
			"searchPerformed": 0,
			"relatedUserAccountId": "712020:mock-human-alex",
			"relatedUserDisplayName": "Alex Rivera",
			"lastViewedAt": "2026-08-21T15:10:00.000Z"
		},
		{
			"agentType": "replit",
			"accountId": "712020:mock-agent-replit",
			"displayName": "Replit session",
			"views": 79,
			"created": 2,
			"updated": 2,
			"commentCreated": 0,
			"searchPerformed": 1,
			"relatedUserAccountId": "712020:mock-human-sam",
			"relatedUserDisplayName": "Sam Chen",
			"lastViewedAt": "2026-08-21T15:00:00.000Z"
		}
	]
}
